/**
 * 编辑新建 Modal Button 组合
 *  formChild 只接受
 */
import React, {
  useCallback,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from 'react';
import { Button, Modal, Form, message, Space } from 'antd';
const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};
// 居中
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const editModal = (props, ref) => {
  const {
    // 按钮配置
    buttonConfig: {
      type = 'primary',
      // 点击按钮额外的操作 比如设置表单的值
      extraClickHandle = () => {},
      btnText = '按钮文案',
      btnStyle = {},
    },
    // 弹窗标题
    modalTitle,
    width = 800,
    // 确定按钮文案
    okText = '确定',
    // formItemKeyMap: {},
    formChild,
    // 点击确定，发送请求
    requestMethod,
    // 请求完成额外的操作
    requestSuccessHandle = () => {},
    onCancelClick = () => {},
    successMessage,
    children,
    newFieldsData,
  } = props;

  const [form] = Form.useForm();
  const [loading, setloading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (newFieldsData) {
      form.setFieldsValue(newFieldsData);
    }
  }, [newFieldsData]);

  // 为父组件的ref添加方法
  useImperativeHandle(ref, () => ({
    // 设置表单的值
    setFieldsValue: (value) => {
      form.setFieldsValue(value);
    },
    // 获取表单的值
    getFieldsValue: (val) => {
      form.getFieldsValue(val || true);
    },
    // 重置表单
    resetFields: () => {
      form.resetFields();
    },
    // 控制按钮的loading状态
    setModalLoading: setloading,
  }));

  const closeModal = () => {
    onCancelClick?.();
    setVisible(false);
    form.resetFields();
  };

  const clickHandle = useCallback(
    (e) => {
      setVisible(true);
      //  在改变visible的同时去执行extraHandle有问题，
      // 因为父元素透传过来的ref是同一个（在一个页面中不同组件实例接收到的ref是同一个），
      // 所以需要先 使组件rerender一下，使得ref能够切换到当前active组件的方法

      // if (typeof extraClickHandle === 'function') {
      //   extraClickHandle();
      // }
    },
    [extraClickHandle],
  );
  useEffect(() => {
    // !!! 为什么要如此写呢，请看line74至76处
    if (visible && typeof extraClickHandle === 'function') {
      extraClickHandle();
    }

    // return () => {

    // }
  }, [visible]);

  const confirmHandle = (params) => {
    setloading(true);
    form
      .validateFields()
      .then((values) => {
        // 传入请求方法
        if (requestMethod) {
          requestMethod(values).then(({ code, data, msg }) => {
            setloading(false);

            if (code === '00000') {
              message.success(successMessage || '保存成功！');
              closeModal();
              requestSuccessHandle?.();
            } else {
              message.error(msg);
            }
          });
        } else {
          // 没传请求方法
          // 通过ref注入的方法获取form表单的值，自定义请求的方式
        }
      })
      .catch(() => {
        setloading(false);
      });
  };

  return (
    <>
      <Button type={type} style={{ ...btnStyle }} onClick={clickHandle}>
        {btnText}
      </Button>
      <Modal
        width={width}
        title={modalTitle}
        closable
        visible={visible}
        confirmLoading={loading}
        okText={okText}
        onCancel={closeModal}
        onOk={confirmHandle}
        footer={null}
      >
        <Form {...formItemLayout} form={form}>
          {children || formChild}
          <br />
          <Form.Item {...tailLayout}>
            <Space size={100}>
              <Button onClick={closeModal}>取消</Button>
              <Button type="primary" onClick={confirmHandle}>
                {okText}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default forwardRef(editModal);
